export default __webpack_public_path__ + "static/cardImg5-87b237cceef19b033c536801f313cae3.webp";